import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { marketplaceService } from '../services/marketplaceService';
import type { GearRentalPayload } from '../types';

export const gearKey = (params?: Record<string, unknown>) =>
  ['marketplace', 'gear', params] as const;

export const gearItemKey = (slug: string) =>
  ['marketplace', 'gear', 'item', slug] as const;

export function useGear(params?: { category?: string; q?: string; page?: number }) {
  return useQuery({
    queryKey: gearKey(params),
    queryFn: () => marketplaceService.listGear(params),
  });
}

export function useGearItem(slug: string) {
  return useQuery({
    queryKey: gearItemKey(slug),
    queryFn: () => marketplaceService.getGear(slug),
    enabled: !!slug,
  });
}

export function useRentGear() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: GearRentalPayload }) =>
      marketplaceService.rentGear(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['marketplace', 'bookings'] });
    },
  });
}
